import { React, PropTypes } from '../dependencies';
import { restaurantWithSelectedShape } from './propTypes';
import PanelToggleItem from './PanelToggleItem';

const SelectRestaurantsItem = ({ id, name, isSelected, onToggle }) => (
    <PanelToggleItem title={name} isSelected={isSelected} onToggle={() => onToggle(id)} />
);

SelectRestaurantsItem.propTypes = {
    ...restaurantWithSelectedShape,
    onToggle: PropTypes.func.isRequired,
};

SelectRestaurantsItem.defaultProps = {};

export default SelectRestaurantsItem;
